import "@/store"

export const state = () => ({
  list: []
})
export const getters = {
  list: (state) => state.list || []
}
export const mutations = {
  setList(state, payload) {
    state.list = payload || []
  },
  createItem(state, payload) {
    state.list = [...state.list, payload]
  },
  updateItem(state, payload) {
    const f = state.list.findIndex((item) => item.id === payload.id)

    if (f !== -1) {
      state.list = [
        ...state.list.slice(0, f),
        payload,
        ...state.list.slice(f + 1)
      ]
    }
  },
  deleteItem(state, payload) {
    const f = state.list.findIndex((item) => item.id === payload)

    if (f !== -1) {
      state.list = [...state.list.slice(0, f), ...state.list.slice(f + 1)]
    }
  }
}

export const actions = {
  fetch({ commit }) {
    return this.$api
      .get("/admin/structure/innovationterritory/list/")
      .then((res) => {
        if (res && res.data) {
          commit("setList", res.data)
          return res.data || []
        }
      })
      .catch((err) => console.log(err))
  },
  detail(_, payload) {
    return this.$api
      .get("/admin/structure/innovationterritory/" + payload + "/update/")
      .then((res) => {
        if (res && res.data) {
          return res.data || {}
        }
      })
      .catch((err) => console.log(err))
  },
  createItemAction({ commit }, payload) {
    return this.$api
      .post("/admin/structure/innovationterritory/create/", payload.data)
      .then((res) => {
        commit("createItem", res.data)
        return res
      })
      .catch((err) => {
        console.log(err)
      })
  },
  updateItemAction({ commit }, payload) {
    return this.$api
      .patch(
        "admin/structure/innovationterritory/" + payload.id + "/update/",
        payload.data
      )
      .then((res) => {
        commit("updateItem", res.data)
        return res
      })
      .catch((err) => {
        console.log(err)
      })
  },
  removeItem({ commit }, payload) {
    return this.$api
      .delete("admin/structure/innovationterritory/" + payload + "/delete/")
      .then((res) => {
        if (res && res.status >= 200) {
          commit("deleteItem", payload)
          return true
        }
        return false
      })
      .catch((err) => {
        console.log(err)
        return false
      })
  }
}
